import { HttpClient } from "_fil_local_addon/camc-cms-base/index";

class AmcFundChartBase {
    constructor(containerId, fundCode) {
        this.fundCode = fundCode;
        this.containerId = containerId;
        this.httpClient = new HttpClient();
        this.dataGrouping = {
            enabled: true,
            approximation: "open",
        };
        this.bindEvents();
    }

    bindEvents() {
        $(`#${this.containerId}`).on("mouseenter", ".highcharts-button-pressed", function (e) {
            $(this).addClass("keep-pressed");
        });

        $(`#${this.containerId}`).on("mouseleave", ".keep-pressed", function (e) {
            $(this).removeClass("keep-pressed");
        });
    }

    getOffsetMin(dataArray) {
        let startFundDate = new Date(dataArray[0][0]);
        let endFundDate = new Date(dataArray[dataArray.length - 1][0]);
        if (endFundDate.getFullYear() == startFundDate.getFullYear()) {
            let dateDiff = 0;
            return dateDiff;
        }

        let thisYear = endFundDate.getFullYear();
        let thisYearLastDay = new Date(thisYear - 1, 11, 31);
        let thisYearLastDayStr =
            thisYearLastDay.getFullYear().toString() +
            thisYearLastDay.getMonth().toString() +
            thisYearLastDay.getDate().toString();
        let foundDay = thisYearLastDay;
        for (let index = dataArray.length - 1; index > 0; index--) {
            let tmpDate = new Date(dataArray[index][0]);
            let tmpDateStr =
                tmpDate.getFullYear().toString() + tmpDate.getMonth().toString() + tmpDate.getDate().toString();

            if (tmpDateStr == thisYearLastDayStr) {
                foundDay = new Date(dataArray[index][0]);
                break;
            }
            if (tmpDate.getTime() < thisYearLastDay.getTime()) {
                foundDay = new Date(dataArray[index - 1][0]);
                break;
            }
        }
        let dateDiff = Math.abs(Math.round((thisYearLastDay - foundDay) / (1000 * 60 * 60 * 24)));
        if (dateDiff == 0 || dateDiff > 15) {
            dateDiff = 1;
        }

        return dateDiff;
    }

    processData(highchartsArray, minDate = 0, maxDate = 0) {
        const yearInMilliseconds = 365 * 24 * 60 * 60 * 1000;
        const twoYearsInMilliseconds = 2 * yearInMilliseconds;
        const fourYearsInMilliseconds = 4 * yearInMilliseconds;
        const fiveYearsInMilliseconds = 5 * yearInMilliseconds;
        const sixYearsInMilliseconds = 6 * yearInMilliseconds;
        const sevenYearsInMilliseconds = 7 * yearInMilliseconds;

        var highchartsArrayNew = highchartsArray;
        let interval = 0;
        if (
            ["medium", "small"].includes(Foundation.MediaQuery.current) &&
            maxDate - minDate >= twoYearsInMilliseconds
        ) {
            highchartsArrayNew = [];
            interval = 7;
            if (maxDate - minDate >= fiveYearsInMilliseconds) {
                interval = 30;
            } else if (maxDate - minDate >= fourYearsInMilliseconds) {
                interval = 10;
            }
        } else if (Foundation.MediaQuery.atLeast("large") && maxDate - minDate >= fourYearsInMilliseconds) {
            highchartsArrayNew = [];
            interval = 10;
            if (maxDate - minDate >= sevenYearsInMilliseconds) {
                interval = 30;
            }
        }
        if (interval > 0) {
            for (var k = 0; k < highchartsArray.length - 2; k++) {
                if (k % interval == 0) {
                    highchartsArrayNew.push(highchartsArray[k]);
                }
            }
        }

        highchartsArrayNew.push(highchartsArray[highchartsArray.length - 1]);

        return highchartsArrayNew;
    }

    getChartMinDate(maxDate, diff) {
        let maxDay = maxDate.getDate();
        let min = new Date(maxDate.getTime());
        //get first day of this month
        min = new Date(Date.UTC(min.getFullYear(), min.getMonth(), 1));
        min.setMonth(min.getMonth() - diff);

        //get last day of this month
        let lastDayOfMonth = new Date(min.getFullYear(), min.getMonth() + 1, 0);
        // check the min day and last day
        maxDay = maxDay > lastDayOfMonth.getDate() ? lastDayOfMonth.getDate() : maxDay;
        //set the max day for this month
        min.setDate(maxDay + 1);

        return min;
    }
    async render() {
        var performanceUrl = this.getApiUrl();

        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
            data: {
                hasHistory: true,
                fundCodes: this.fundCode,
            },
        };
        const response = await this.httpClient.get(performanceUrl, options);

        var navResData = response.data;

        try {
            if (navResData && navResData.length !== 0) {
                this.data = this.mergeData(navResData);
                this.createChart(this.data);
            } else {
                this.setEmptyMessage();
            }
        } catch (error) {
            this.setEmptyMessage();
            throw new Error("Chart Render Error");
        }
    }
    mergeNavData(navResData) {
        let navDataArray = [];
        navResData.sort(function (a, b) {
            var priceDateA = a.priceDate; // ignore upper and lowercase
            var priceDateB = b.priceDate; // ignore upper and lowercase
            if (priceDateA > priceDateB) {
                return 1;
            } else {
                return -1;
            }
        });
        var priceDate = "";
        var navData;

        for (var i = 0; i < navResData.length; i++) {
            var element = navResData[i];
            priceDate = element.priceDate;
            var priceDateLong = new Date(priceDate) * 1;
            navData = {
                x: priceDateLong,
                y: element.nav,
                navDecimalPlace: element.navDecimalPlace,
            };
            navDataArray.push(navData);
        }
        return { navDataArray, priceDate };
    }
    mergePerformanceData(performanceResData) {
        if (performanceResData.length < 1) {
            throw new Error("Chart Render Error");
        }

        const performanceDataArrayApi = [];
        const bmInfoDataMap = {};
        let priceDate = "";

        performanceResData.sort((a, b) => new Date(a.reinvestedPriceDate) - new Date(b.reinvestedPriceDate));

        const allBmInfoLengthIsOne = performanceResData.every(
            (item) => item.bmInfo === null || (item.bmInfo && item.bmInfo.length === 1),
        );

        if (allBmInfoLengthIsOne) {
            performanceResData = performanceResData.map((item) => {
                if (item.bmInfo) {
                    item.indexName = "业绩基准";
                    item.bmInfo[0].indexName = "业绩基准";
                }
                return item;
            });
        }

        const firstBmReinvestedData = performanceResData.find((data) => data.bmReinvestedPrice);
        const firstBmInfoData = performanceResData.find((data) => data.bmInfo);

        if (firstBmReinvestedData) {
            bmInfoDataMap["DEFAULT"] = {
                indexName: "业绩基准",
                data: [],
                index: {
                    indexCode: "DEFAULT",
                    indexName: "业绩基准",
                },
            };
            performanceResData[0].bmInfo = [
                {
                    indexCode: "DEFAULT",
                    indexName: "业绩基准",
                    bmReinvestedPrice: performanceResData[0].bmReinvestedPrice,
                },
            ];
            delete performanceResData[0].bmReinvestedPrice;
        } else if (firstBmInfoData) {
            firstBmInfoData.bmInfo.forEach((item) => {
                bmInfoDataMap[item.indexCode] = {
                    indexName: item.indexName,
                    data: [],
                    index: {
                        indexCode: item.indexCode,
                        indexName: item.indexName,
                    },
                };
            });
        }

        performanceResData.forEach((element, i) => {
            if (i === 0) return;

            const preElement = performanceResData[i - 1];
            if (element.bmReinvestedPrice) {
                element.bmInfo = [
                    {
                        indexCode: "DEFAULT",
                        indexName: "业绩基准",
                        bmReinvestedPrice: element.bmReinvestedPrice,
                    },
                ];
                delete element.bmReinvestedPrice;
            }

            priceDate = element.reinvestedPriceDate;
            const priceDateLong = new Date(priceDate).getTime();

            if (i === 1) {
                if (
                    preElement.bmInfo?.every(
                        (info) => isNaN(Number(info.bmReinvestedPrice)) || Number(info.bmReinvestedPrice) === 0,
                    ) ||
                    isNaN(Number(preElement.reinvestedPrice)) ||
                    Number(preElement.reinvestedPrice) === 0
                ) {
                    throw new Error("Chart Render Error");
                }
            }

            const performanceDataApi = {
                x: priceDateLong,
                currentDateValue: element.reinvestedPrice,
                preDateValue: preElement.reinvestedPrice,
            };

            Object.keys(bmInfoDataMap).forEach((bmCode) => {
                bmInfoDataMap[bmCode].data.push({
                    x: priceDateLong,
                    currentDateValue:
                        element.bmInfo?.find((item) => item.indexCode === bmCode)?.bmReinvestedPrice ?? null,
                    preDateValue:
                        preElement.bmInfo?.find((item) => item.indexCode === bmCode)?.bmReinvestedPrice ?? null,
                });
            });

            performanceDataArrayApi.push(performanceDataApi);
        });

        return { performanceDataArrayApi, bmInfoDataMap, priceDate };
    }
    errorHandler() {}
    setEmptyMessage() {}
    createChart(data) {}
    mergeData() {}
    /**
     *
     * @param {*} dataList
     * @returns [[longtime, changeValue]]
     * data item [datalongtime, dateValue, predateValue]
     */
    getNavData(dataList, dataMin, dataMax) {
        // let data0 = dataList[0]?.preDateValue;
        let start = 0;
        let end = dataList.length - 1;
        let result = [];
        for (let index = 0; index <= dataList.length - 1; index++) {
            if (!dataMin) {
                break;
            }
            if (dataList[index]["x"] >= dataMin) {
                start = index;
                break;
            }
        }

        for (let index = dataList.length - 1; index >= 0; index--) {
            if (!dataMax) {
                break;
            }
            if (dataList[index]["x"] <= dataMax) {
                end = index;
                break;
            }
        }

        for (let index = start; index <= end; index++) {
            result.push(dataList[index]);
        }
        result = this.processData(result, dataMin, dataMax);
        return result;
    }
    getPerformanceChangeData(dataList, dataMin, dataMax) {
        if (!(dataList.length > 0 && dataList[0]?.preDateValue)) {
            return [];
        }

        let data0 = dataList[0]?.preDateValue;
        let result = [];
        let start = 0;
        let end = dataList.length - 1;

        for (let index = 0; index <= dataList.length - 1; index++) {
            if (!dataMin) {
                break;
            }
            if (dataList[index]["x"] >= dataMin) {
                start = index;
                break;
            }
        }

        for (let index = dataList.length - 1; index >= 0; index--) {
            if (!dataMax) {
                break;
            }
            if (dataList[index]["x"] <= dataMax) {
                end = index;
                break;
            }
        }
        data0 = dataList[start].preDateValue;

        let rePerformance = 0;

        for (let index = start; index <= end; index++) {
            let item = dataList[index];
            rePerformance = item.currentDateValue / data0 - 1;

            if (item.currentDateValue != null) {
                result.push({
                    x: item["x"],
                    y: rePerformance * 100,
                    currentDateValue: item.currentDateValue,
                    preDateValue: item.preDateValue,
                });
            }
        }

        result = this.processData(result, dataMin, dataMax);

        return result;
    }

    scrollByPixels(e, x = 0, y = 0) {
        if (typeof e === "string") {
            e = $(e);
        }
        e.stop().animate({
            scrollLeft: "+=" + x,
            scrollTop: "+=" + y,
        });
    }

    updateExtremes(rangeButtonOption) {
        let { minDate, maxDate } = this.getExtremesMinAndMaxDate(rangeButtonOption);

        this.chart.xAxis[0].setExtremes(minDate, maxDate);
    }

    getExtremesMinAndMaxDate(rangeButtonOption) {
        let rangeType = rangeButtonOption.type;
        let minDate = this.startFundDate;
        let maxDate = this.endFundDate;

        if (rangeType === "ytd") {
            minDate = new Date(Date.UTC(maxDate.getFullYear(), 0, 1)).getTime() + rangeButtonOption.offsetMin;
            minDate = this.startFundDate > minDate ? this.startFundDate : minDate;
        } else if (rangeType === "month" || rangeType === "year") {
            let diff = rangeType == "month" ? rangeButtonOption.count : rangeButtonOption.count * 12;
            minDate = this.getChartMinDate(maxDate, diff);
        } else {
            //all
            minDate = this.startFundDate;
            maxDate = this.endFundDate;
        }
        if (minDate instanceof Date) {
            minDate = minDate.getTime();
        }
        if (maxDate instanceof Date) {
            maxDate = maxDate.getTime();
        }

        return { minDate, maxDate };
    }
}

export default AmcFundChartBase;
